import React from "react";
import Default from "./Default";


const Vervanger = () => {
    return (
        <Default />
    )
};

export default Vervanger;